import React, {
  useCallback, useEffect, useLayoutEffect, useRef, useState,
} from "react";
import moment from "moment";

import { NavBar } from "./Components/Navbar";
import { ChartData } from "./Components/ChartData";
import { ChooseTimestamp } from "./Components/ChooseTimestamp";
import { ChooseField } from "./Components/ChooseField";
import { Footer } from "./Components/Footer";

export const Main = () => {
  const [state, setState] = useState({
    chartData: [],
    showNoDataAlert: false,
    label: "",
    field: "",
    borderColor: "",
    lastDate: "minute",
    isLoading: false,
  });

  const handleChange = (objValue) => setState((prevState) => ({ ...prevState, ...objValue }));
  const dynamicColors = () => {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgb(${r},${g},${b})`;
  };

  const getIotData = useCallback(async () => {
    let lastDate = null;
    switch (state.lastDate) {
      case "minute":
        lastDate = moment().subtract(1, "minute");
        break;
      case "hour":
        lastDate = moment().subtract(1, "hour");
        break;
      case "day":
        lastDate = moment().subtract(1, "day");
        break;
      case "week":
        lastDate = moment().subtract(1, "week");
        break;
      case "month":
        lastDate = moment().subtract(1, "month");
        break;
      case "year":
        lastDate = moment().subtract(1, "year");
        break;
      default:
        lastDate = undefined;
    }
    if (state.field) {
      const payload = { field: state.field, last_date: lastDate };
      try {
        const response = await fetch("https://iotghifari.herokuapp.com/field", {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
            "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(payload), // body data type must match "Content-Type" header);
        });

        if (response.status === 200) {
          const result = await response.json();
          if (result.data.length > 0) {
            const chartData = result.data.map((item) => ({
              x: item.timeseries,
              y: item.value,
            }));
            return handleChange({
              chartData,
              label: state.field,
              borderColor: state.isLoading ? dynamicColors()
                : state.borderColor,
              isLoading: false,
              showNoDataAlert: false,
            });
          }
        }
      } catch (error) {
        // return error;
      }
      return handleChange({
        chartData: [],
        label: "",
        borderColor: state.isLoading ? dynamicColors()
          : state.borderColor,
        isLoading: false,
        showNoDataAlert: true,
      });
    }

    return false;
  }, [state.chartLabel, state.field, state.isLoading]);

  function useInterval(callback, delay) {
    const savedCallback = useRef(callback);

    // Remember the latest callback if it changes.
    useLayoutEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      // Don't schedule if no delay is specified.
      // Note: 0 is a valid value for delay.
      if (!delay && delay !== 0) {
        return;
      }

      const id = setInterval(() => savedCallback.current(), delay);

      // eslint-disable-next-line consistent-return
      return () => clearInterval(id);
    }, [delay]);
  }

  useInterval(getIotData, 3000);

  return (
    <div>
      <NavBar />
      <div className="my-5 mx-5 d-flex justify-content-center">
        <div className="w-75">
          <ChooseTimestamp
            handleChange={handleChange}
            lastDate={state.lastDate}
          />
          <ChartData
            label={state.label}
            data={state.chartData}
            borderColor={state.borderColor}
          />
          <div className="d-flex justify-content-center">
            <div className="w-50 my-5">
              <ChooseField
                handleChange={handleChange}
                field={state.field}
                showNoDataAlert={state.showNoDataAlert}
                isLoading={state.isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
